import React from 'react';
import { WorkPageLayout } from '../Layout';
import styles from './How.module.scss';

export const HowMainSection = () => (
  <WorkPageLayout
    isMain
    leftContent={
      <div className={styles.howLeftSection}>
        <span className={styles.howMain_1}>How</span>
        <span className={styles.howMain_2}>does it</span>
        <span className={styles.howMain_3}>work?</span>
      </div>
    }
    rightContent={null}
  />
);
